module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "升级为更高星级俱乐部",
      "is-link": ""
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubHighApply')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('van-dialog', {
    staticClass: "dialog-box",
    attrs: {
      "title": "",
      "showConfirmButton": false
    },
    model: {
      value: (_vm.clubShow),
      callback: function($$v) {
        _vm.clubShow = $$v
      },
      expression: "clubShow"
    }
  }, [_c('div', {
    staticClass: "dialog-head"
  }, [_vm._v("创建须知")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("1.积分要求：")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（1）积分≥800可升级成为理事单位")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（2）积分≥1000可升级成为副主席单位")])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("2.会员单位升级类别")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（1）理事单位")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（2）副主席单位")])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("3.附件下载\n          "), _c('div', {
    staticClass: "dialog-step-li-text",
    on: {
      "click": function($event) {
        return _vm.download('2021年全国啦啦操七彩星级管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1621826258255-13.pdf')
      }
    }
  }, [_vm._v("\n            2021年全国啦啦操七彩星级管理办法\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li-text",
    on: {
      "click": function($event) {
        return _vm.download('043号-全国啦啦操关于建设“全国啦啦操星级俱乐部”的通知', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1621826258255-11.pdf')
      }
    }
  }, [_vm._v("\n            043号-全国啦啦操关于建设“全国啦啦操星级俱乐部”的通知\n          ")])]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.toNext('ClubDanweiApply')
      }
    }
  }, [_c('div', [_vm._v("我已阅读并同意遵守本须知声明的所有条款")]), _vm._v(" "), _c('div', [_vm._v("点击进行创建")])]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.clubShow = false
      }
    }
  }, [_vm._v("我再想想")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d4fda9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailDanwei.vue
// module id = 2374
// module chunks = 0